import React from 'react'
const CardGenerated = ({item, userId}) => {
    //console.log(item)
    return (
        <>
            <div className="bg-transparent rounded-xl h-44 lg:h-52 xl:h-80 flex flex-row  self-center">
                <img className="rounded-lg h-44 lg:h-52 xl:h-80 w-4/6 sm:w-64 xl:w-82 object-cover" src={`https://polar-castle-07148.herokuapp.com/api/user/images/wardrobe/${userId}/${item.itemUrl}`}/>
                <div className=" p-4 bg-transparent rounded-xl w-32 flex-col justify-center ">
                    <p className="font-bold">{item.brand}</p>
                    <p>{item.occasion}</p>
                    <p>{item._styletype}</p>
                    <p>{item.style}</p>
                </div>
            </div>
           

        </>
    )
}

export default CardGenerated